import React, { useEffect, useState } from "react";
import FinanceService from "../../../../service/FinanceService";
import { getOrderStatusEnumText } from "../../../../utils/getEnumText";
import {
  Button,
  Card,
  DatePicker,
  Form,
  Select,
  Statistic,
  Table,
  Tag,
} from "antd";
import locale from "antd/es/date-picker/locale/ru_RU";
import CityService from "../../../../service/CityService";
import { formatDate } from "../../../../utils/notificationUtil";

interface ICity {
  _id: string;
  titleRU: string;
  titleCN: string;
}

interface ICityList {
  cities: ICity[];
  currentPage: number;
  total: number;
}

const KazakhstanOrdes = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const [reports, setReports] = useState<any>([]);

  const [cities, setCitites] = useState<ICityList>({
    cities: [],
    currentPage: 1,
    total: 0,
  });

  useEffect(() => {
    async function fetchCitits() {
      const res = await CityService.fetchFilter(1, 100);

      setCitites(res.data);
    }
    fetchCitits();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "追踪码",
      dataIndex: "barCode",
      key: "barCode",
    },

    {
      title: "号码组",
      key: "orderGroup",
      dataIndex: "orderGroup",
      render: (text: string, record: any) => {
        return <p>{record?.orderGroup?.title}</p>;
      },
    },

    {
      title: "状况",
      key: "status",
      dataIndex: "status",
      render: (text: string, record: any) => {
        const data = getOrderStatusEnumText(record.status);
        if (data) {
          return <Tag color={data.color}>{data.text}</Tag>;
        }
      },
    },

    {
      title: "日期/Дата",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (text: string, record: any) => {
        return <p>{formatDate(record.createdAt)}</p>;
      },
    },

    // {
    //   title: "更多",
    //   key: "action",
    //   render: (text: string, record: any) => (
    //     <>
    //       <Space size="middle">
    //         <Button
    //           danger
    //           type="primary"
    //           onClick={() => {
    //             deleteCityConfirm(record._id);
    //           }}
    //         >
    //           删除
    //         </Button>
    //       </Space>
    //       <Space size="middle">
    //         <Button
    //           type="primary"
    //           onClick={() => {
    //             showDrawerEdit(record);
    //           }}
    //         >
    //           修改
    //         </Button>
    //       </Space>
    //     </>
    //   ),
    // },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const status = form.getFieldValue("status");
    const startDate = form.getFieldValue("startDate");
    const endDate = form.getFieldValue("endDate");
    const res = await FinanceService.reportChina(page, 12, {
      status,
      startDate,
      endDate,
    });
    setReports(res.data);
    setLoading(false);
  };

  const onFinish = async (value: any) => {
    // console.log(value);

    const response = await FinanceService.reportKazakhstan(1, 12, value);
    // console.log(response);
    setReports(response.data);
  };
  return (
    <>
      <Card>
        {" "}
        <Form
          form={form}
          layout="inline"
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            style={{ marginTop: 16 }}
            label="日期从/Дата от"
            name="startDate"
            required
          >
            <DatePicker locale={locale} />
            {/* </ConfigProvider> */}
          </Form.Item>

          <Form.Item
            style={{ marginTop: 16 }}
            label="日期至/Дата до"
            name="endDate"
            required
          >
            <DatePicker locale={locale} />
          </Form.Item>
          <Form.Item
            style={{ marginTop: 16 }}
            label="城市/Город"
            name="dest_city"
            required
          >
            <Select
              // defaultValue={type || BarCodeType.PACKAGE}
              style={{ width: 180 }}
              options={cities.cities.map((item: ICity) => ({
                label: item.titleRU + "/" + item.titleCN,
                value: item._id,
              }))}
            />
          </Form.Item>
          <Form.Item
            style={{ marginTop: 16 }}
            label="状态/Статус"
            name="status"
            required
          >
            <Select
              // defaultValue={type}
              style={{ width: 480 }}
              options={[
                {
                  value: "SENT_FROM_KZ_INNER",
                  label:
                    "哈国内部发货数量/Количество внутренних отправлений по Казахстану",
                },
                {
                  value: "RECIEVED_FROM_KZ_INNER",
                  label:
                    "哈国内部接货数量/Количество товаров, полученных филиалом в Казахстане",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            style={{ marginTop: 16 }}
            // wrapperCol={{ offset: 8, span: 16 }}
          >
            <Button type="primary" htmlType="submit">
              OK
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <Statistic title="订单数量/Количество заказов" value={reports?.total} />

        <Table
          loading={loading}
          rowKey={(record) => record._id}
          columns={columns}
          dataSource={reports?.result}
          scroll={{ y: 460 }}
          pagination={{
            pageSize: 12,
            total: reports?.total,
            current: reports?.currentPage,
            onChange: pageChangeHandle,
          }}
        />
      </Card>
    </>
  );
};

export default KazakhstanOrdes;
